module.exports = __webpack_public_path__ + "static/media/chat.bd4071fc.svg";